import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './parts.css'

/**
 * The header region of a composed [Modal](/components/modal/). A fixed zone that
 * sits beside the modal's close button; bring your own heading element.
 *
 * Auto-assigns itself to the modal's `header` slot, so place it as a direct
 * child of `nord-modal` (no `slot` attribute needed).
 *
 * @status draft
 * @category overlay
 * @lightDom true
 *
 * @slot - The modal header content.
 */
@customElement('nord-modal-header')
export default class ModalHeader extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    if (!this.hasAttribute('slot')) {
      this.setAttribute('slot', 'header')
    }
    injectLegacyLightDomStyles(this, style, 'nord-modal-parts')
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-modal-header': ModalHeader
  }
}
